module.exports = __webpack_public_path__ + "media/chat_alert.b81828c2.mp3";